import { Component, EventEmitter, Input, NgModule, Output, TemplateRef, ViewChild } from '@angular/core';
import { DxButtonModule, DxDateBoxModule, DxFormComponent, DxFormModule, DxNumberBoxModule, DxScrollViewModule, DxSelectBoxModule, DxTextBoxModule, DxToolbarModule, DxValidatorModule } from 'devextreme-angular';
import { getSizeQualifier, ScreenService } from '../../../services';
import { ApplyPipeModule } from '../../../pipes/apply.pipe';
import { CommonModule } from '@angular/common';

type CardData = Record<string, any>;

@Component({
  selector: 'quick-action-card',
  templateUrl: './quick-action-card.component.html',
  styleUrls: ['quick-action-card.component.scss'],
})
export class QuickActionCardComponent {
  @ViewChild('form', { static: true }) form!: DxFormComponent;
  @Input() title: string = '';
  @Input() cardData!: CardData;
  @Input() items: Record<string, any>[] = [];
  @Input() colCount: number = 2;
  @Output() dataChanged = new EventEmitter<any>();


  getSizeQualifier = getSizeQualifier;

  assign = Object.assign;

  constructor(public screen: ScreenService) {}

  onFieldChange(fieldName?, value?) {
    const {isValid} = this.form.instance.validate();

    if (!isValid) {
      return;
    }

  }

  getFieldValue(cardData, fieldName) {
    return cardData[fieldName];
  }
}

@NgModule({
  imports: [
    ApplyPipeModule,
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxNumberBoxModule,
    DxToolbarModule,
    DxSelectBoxModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxValidatorModule,
    CommonModule
  ],
  declarations: [QuickActionCardComponent],
  exports: [QuickActionCardComponent],
})
export class QuickActionCardModule { }

